import React, { Component } from 'react';
import { Col } from 'react-bootstrap';

import { Chart } from 'react-google-charts';

export class DonutsChartPanel extends Component {

    isDataPresent = () => {
      if (this.props.routesList.filter((route) => {
        return route.selected;
      }).length > 0) {return true} else {return false}
    }

    getChartColors = () => {
      return this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        return '' + route.pathColor;
      })

    }

    getChartData = () => {

      let totDrive = 0;
      let totDuty = 0;
      let totOff = 0;
      let totTime = 0;

      this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        //chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
        //chartData.push([route.from.name + ' ' + route.to.name, route.endDate.getHours()-route.startDate.getHours()]);
        totDrive += route.drive;
        totDuty += route.duty;
        totOff += route.off;
        totTime += route.time;

        return null;
      });

      var chartData = [['drive (hr)', totDrive],['duty (hr)', totDuty],['off (hr)', totOff],['time (hr)', totTime]];
      return chartData;
    }

    getSecondChartData = () => {

      let totRevenue = 0;
      let totFuel = 0;
      let totTolls = 0;

      this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        //chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
        //chartData.push([route.from.name + ' ' + route.to.name, route.endDate.getHours()-route.startDate.getHours()]);
        totRevenue += route.revenue;
        totFuel += route.fuel;
        totTolls += route.tolls;

        return null;
      });

      var chartData = [['revenue ($/hr)', totRevenue],['fuel ($/hr)', totFuel],['tolls ($/hr)', totTolls]];
      return chartData;
    }

    getChart = () => {
      if (this.isDataPresent()) {
        return (
          <Chart
            chartType="PieChart"
            rows={this.getChartData()}
            columns={[
                    {
                      type: 'string',
                      label: 'label',
                    },
                    {
                      type: 'number',
                      label: 'value',
                    }
                  ]}
            options={{
                title: 'Time reference',
                pieHole: 0.5,
                pieSliceTextStyle: {
                  color: 'black',
                }
              }}
            graph_id="PieChart"
            width="100%"
            height="160px"
          />
        )
      } else {
        return <span></span>;
      }
    }

    getSecondChart = () => {
      if (this.isDataPresent()) {
        return (
          <Chart
            chartType="PieChart"
            rows={this.getSecondChartData()}
            columns={[
                    {
                      type: 'string',
                      label: 'Age',
                    },
                    {
                      type: 'number',
                      label: 'Weight',
                    }
                  ]}
            options={{
                title: 'Cash reference',
                pieHole: 0.5,
                pieSliceTextStyle: {
                  color: 'black',
                },
                colors: ['#f4e842', '#ffb30f','#ff630f', '#af0000']
              }}
            graph_id="PieChart2"
            width="100%"
            height="160px"
          />
        )
      } else {
        return <span></span>;
      }
    }

    render() {
        return(

          <div className={'my-pretty-chart-container'}>
          <Col xs={6} sm={6} md={6} lg={6} >
            {this.getChart()}
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} >
            {this.getSecondChart()}
          </Col>
          <div className="clearfix"></div>
          </div>
        );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/DonutsChartPanel.js